var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOeMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "oe-mobile",
    width: 64,
    height: 52,
    viewBox: "0 0 64 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 52,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.955 23.9738C36.6562 22.0444 38.6047 20.6569 40.8979 20.6569C43.1912 20.6569 45.1397 22.0444 45.8409 23.9738H35.955ZM23.1713 31.4194C20.1281 31.4194 17.6611 29.0061 17.6611 26.0291C17.6611 23.052 20.1281 20.6387 23.1713 20.6387C26.2146 20.6387 28.6816 23.052 28.6816 26.0291C28.6816 29.0052 26.2146 31.4194 23.1713 31.4194ZM41.0132 17C36.6013 17 32.934 20.1938 32.1911 24.3979C31.4075 20.2216 27.6675 17.0564 23.1713 17.0564C18.1061 17.0564 14 21.0731 14 26.0282C14 30.9832 18.1061 35 23.1713 35C27.4955 35 31.1211 32.0715 32.0883 28.132C33.0607 32.0447 36.5924 34.9436 40.8013 34.9436C44.3046 34.9436 47.5677 32.9352 49.0481 30.0051H44.8356C44.0848 30.6953 43.0343 31.5131 40.8979 31.5131C37.3016 31.5131 35.9639 28.491 35.5579 27.2093H49.9851C50.2936 21.5171 45.7726 17 41.0132 17Z",
    fill: "#FB3449"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOeMobile);
export default __webpack_public_path__ + "static/media/oe_mobile.099f5897f9d8ec6a9cfbf1ebc53f4783.svg";
export { ForwardRef as ReactComponent };